export default __webpack_public_path__ + "static/media/menu-icon-white.b3d60721.svg";